import { parseISO } from "date-fns";
import AgentDomain from "entities/domain/agents/agent-domain";
import { AgentMerchantDomain } from "entities/domain/agents/agent-merchant-domain";
import { AgentMerchantRoleDomain } from "entities/domain/agents/agent-merchant-role-domain";
import AgentNotificationConfigDomain from "entities/domain/agents/agent-notification-config-domain";
import {
  AdminAgentDTO,
  AgentMerchantDTO,
  AgentMerchantRoleDTO,
  AgentNotificationConfigDTO,
} from "entities/dto/AdminAgentDTO";

export const transformNotificationConfigfromDtoToDomain = (
  d: AgentNotificationConfigDTO
): AgentNotificationConfigDomain =>
  new AgentNotificationConfigDomain(
    d.handle,
    d.channel,
    d.preference,
    d.strategy ?? "",
    d.timezone,
    d.disabled_channels ?? [],
    d.custom_configs ?? []
  );

export const agentRolesTransformFromDtoToDomain = (
  role: AgentMerchantRoleDTO
): AgentMerchantRoleDomain =>
  new AgentMerchantRoleDomain(role.id, role.name, role.permissions);

export const adminAgentTransformFromDtoToDomain = (
  agent: AdminAgentDTO,
  color: string
): AgentDomain =>
  new AgentDomain(
    agent.id,
    agent.name,
    agent.surname,
    agent.email,
    agent.phone,
    agent.contact_channel,
    agent.notification_config
      ? transformNotificationConfigfromDtoToDomain(agent.notification_config)
      : null,
    agent.merchants.map((am: AgentMerchantDTO): AgentMerchantDomain => {
      return new AgentMerchantDomain(
        am.id,
        am.name,
        am.logo,
        agentRolesTransformFromDtoToDomain(am.role),
        am.is_active,
        am.rotation_enabled
      );
    }),
    agent.user_id,
    agent.profile_picture,
    color,
    agent.player_ids,
    agent.style_preferences
      ? {
          chatBackground: agent.style_preferences.chat_background,
          colorScheme: agent.style_preferences.color_scheme,
        }
      : null,
    agent.last_active_at
      ? parseISO(
          agent.last_active_at.includes("Z")
            ? agent.last_active_at
            : `${agent.last_active_at}Z`
        )
      : null
  );
